import { Component, Directive, ElementRef, inject, Injector, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  selector: 'events-directive',
  standalone: false
})
export class EventsDirective extends UpgradeComponent {
  @Input() filterId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('events', elementRef, injector);
  }
}

@Component({
  selector: 'events-component',
  template: '<events-directive [filterId]="filterId"></events-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EventsComponent {
  @Input() filterId: string;
}

@Directive({
  selector: 'event-view-directive',
  standalone: false
})
export class EventViewDirective extends UpgradeComponent {
  @Input() eventId: string;
  @Input() eventObj: string;
  @Input() user: string;
  @Input() tearoff: string;
  @Input() scrollTo: string;
  @Input() token: string;
  @Input() action: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('eventViewComponent', elementRef, injector);
  }
}

@Component({
  selector: 'event-view-component',
  template: '<event-view-directive [eventId]="eventId" [eventObj]="eventObj" [user]="user" [tearoff]="tearoff" [scrollTo]="scrollTo" [action]="action"></event-view-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EventViewComponent {
  @Input() eventId: string;
  @Input() eventObj: string;
  @Input() user: string;
  @Input() tearoff: string;
  @Input() scrollTo: string;
  @Input() token: string;
  protected action: string;

  private route = inject(ActivatedRoute);

  constructor() {
    this.route.data.subscribe(data => {
      this.action = data['action'];
    });
  }
}

@Directive({
  selector: 'tearoff-event-view-directive',
  standalone: false
})
export class TearoffEventViewDirective extends UpgradeComponent {
  @Input() eventId: string;
  @Input() eventObj: string;
  @Input() user: string;
  @Input() tearoff: string;
  @Input() scrollTo: string;
  @Input() token: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('tearoffEventViewComponent', elementRef, injector);
  }
}

@Component({
  selector: 'tearoff-event-view-component',
  template: '<tearoff-event-view-directive [eventId]="eventId" [eventObj]="eventObj" [user]="user" [tearoff]="tearoff" [scrollTo]="scrollTo"></tearoff-event-view-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TearoffEventViewComponent {
  @Input() eventId: string;
  @Input() eventObj: string;
  @Input() user: string;
  // @Input() tearoff: string;
  tearoff = 'true';
  @Input() scrollTo: string;
  @Input() token: string;
}

@Directive({
  selector: 'manage-timelines-directive',
  standalone: false
})
export class ManageTimelinesDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('manageTimelines', elementRef, injector);
  }
}

@Component({
  selector: 'manage-timelines-component',
  template: '<manage-timelines-directive></manage-timelines-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ManageTimelinesComponent {
}

@Directive({
  selector: 'new-event-directive',
  standalone: false
})
export class NewEventDirective extends UpgradeComponent {
  @Input() user: string;
  @Input() defaults: string;
  @Input() convertingADraft: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('newEventComponent', elementRef, injector);
  }
}

@Component({
  selector: 'new-event-component',
  template: '<new-event-directive [user]="user" [defaults]="defaults" [convertingADraft]="convertingADraft"></new-event-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NewEventComponent {
  @Input() user: string;
  @Input() defaults: string;
  @Input() convertingADraft: string;
}

@Directive({
  selector: 'event-section-directive',
  standalone: false
})
export class EventSectionDirective extends UpgradeComponent {
  @Input() eventSectionId: string;
  @Input() eventTypeId: string;
  @Input() eventOwner: string;
  @Input() action: string;
  @Input() user: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('eventSectionComponent', elementRef, injector);
  }
}

@Component({
  selector: 'event-section-component',
  template: '<event-section-directive [eventSectionId]="eventSectionId" [eventTypeId]="eventTypeId" [eventOwner]="eventOwner" [action]="action" [user]="user"></event-section-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EventSectionComponent {
  @Input() eventSectionId: string;
  @Input() eventTypeId: string;
  @Input() eventOwner: string;
  @Input() user: string;

  action: string;

  private route = inject(ActivatedRoute);

  constructor() {
    this.route.data.subscribe(data => {
      this.action = data['action'];
    });
  }

}

@Directive({
  selector: 'event-section-view-directive',
  standalone: false
})
export class EventSectionViewDirective extends UpgradeComponent {
  @Input() eventSectionId: string;
  @Input() eventSection: string;
  @Input() scrollTo: string;
  @Input() user: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('eventSectionViewComponent', elementRef, injector);
  }
}

@Component({
  selector: 'event-section-view-component',
  template: '<event-section-view-directive [eventSectionId]="eventSectionId" [eventSection]="eventSection" [scrollTo]="scrollTo" [user]="user"></event-section-view-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EventSectionViewComponent {
  @Input() eventSectionId: string;
  @Input() eventSection: string;
  @Input() scrollTo: string;
  @Input() user: string;
}


@Directive({
  selector: 'select-tags-directive',
  standalone: false
})
export class SelectTagsDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('selectTagsComponent', elementRef, injector);
  }
}

@Component({
  selector: 'select-tags-component',
  template: '<select-tags-directive></select-tags-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SelectTagsComponent {
}

@Directive({
  selector: 'apply-tags-directive',
  standalone: false
})
export class ApplyTagsDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('applyTagsComponent', elementRef, injector);
  }
}

@Component({
  selector: 'apply-tags-component',
  template: '<apply-tags-directive></apply-tags-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ApplyTagsComponent {
}

@Directive({
  selector: 'all-events-directive',
  standalone: false
})
export class AllEventsDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('allEventsComponent', elementRef, injector);
  }
}

@Component({
  selector: 'all-events-component',
  template: '<all-events-directive></all-events-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AllEventsComponent {
}
